import React, { useState } from 'react';
import axios from 'axios';
import styles from './opponentModal.module.css';

export default function OpponentModal({ onClose, onAdd }) {
    const [team, setTeam] = useState('');
    const [googleMapsLink, setGoogleMapsLink] = useState('');
    const [iconFile, setIconFile] = useState(null);

    const handleAdd = async () => {
        let imgPath = '';

        if (iconFile) {
            const formData = new FormData();
            formData.append('icon', iconFile);

            const uploadRes = await axios.post('/api/upload/upload-opponent-icon', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            imgPath = uploadRes.data.path;
        }

        const res = await axios.post('/api/opponents', {
            team,
            img_path: imgPath,
            google_maps_link: googleMapsLink,
        });

        onAdd(res.data);
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <h3>Gegner hinzufügen</h3>
                <label>
                    Team Name
                    <input value={team} onChange={(e) => setTeam(e.target.value)} />
                </label>
                <label>
                    Gegner-Logo (Bild)
                    <input type="file" accept="image/*" onChange={(e) => setIconFile(e.target.files[0])} />
                </label>
                <label>
                    Google Maps Link des Sportplatzes
                    <input value={googleMapsLink} onChange={(e) => setGoogleMapsLink(e.target.value)} />
                </label>

                <div className={styles.modalButtons}>
                    <button className={styles.redButton} onClick={onClose}>Abbrechen</button>
                    <button className={styles.addButton} onClick={handleAdd}>Hinzufügen</button>
                </div>
            </div>
        </div>
    );
}
